/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.
 
This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.
 
License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.
 
This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.
 
For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/

import {
  AppContext,
  AppLayoutProvider,
  useCreateTheme,
} from "eworldes-ui-toolkit-v1.1.0";
import { useSelector } from "react-redux";
import { selectLayout } from "selectors";
import { defaultThemes } from "./theme";
import { router } from "./routing";
import "styles/app.css";
import { RouterProvider } from "react-router-dom";

import { ChatBot } from './components/ChatBot';

function App() {
  const { themeMode } = useSelector(selectLayout);
  //@ts-ignore
  const theme = useCreateTheme(defaultThemes[themeMode || "light"]);

  return (
    <AppContext.Provider value={{ router }}>
      <AppLayoutProvider theme={theme} router={router}>
        <RouterProvider
          router={router}
          fallbackElement={<div>Loading app...</div>}
        />
        <ChatBot />
      </AppLayoutProvider>
    </AppContext.Provider>

  );
}

export default App;
